import { ObjectShim } from '@packages/helpers/core/shims/object-shim';
import { parsePropertyId } from '../../helpers/property-portfolio';
import { sendUserAttribute, getSpecifiedUserAttribute } from './user-attributes/actions';

export const getProperties = getSpecifiedUserAttribute('property');
export const getMortgages = getSpecifiedUserAttribute('mortgage');
export const sendProperty = sendUserAttribute('property');
export const sendMortgage = sendUserAttribute('mortgage');

export const deleteMortgage =
  (...ids) =>
  (dispatch, getState) => {
    const items = getState().userAttributes.mortgage.items;

    if (ids.every(id => id in items)) {
      return dispatch(
        sendMortgage({
          items: ObjectShim.omit(items, ids)
        })
      );
    }
  };

export const deleteProperty = id => async (dispatch, getState) => {
  const items = getState().userAttributes.property.items;

  if (id in items) {
    const response = await dispatch(
      sendProperty({
        items: ObjectShim.omit(items, [id])
      })
    );

    if (!response.errorMsg) {
      const items = getState().userAttributes.mortgage.items;

      const ids = Object.keys(items).filter(key => id === parsePropertyId(key));

      return dispatch(deleteMortgage(...ids));
    }
  }
};

export const updateProperty =
  (id, property, updatedProperties = {}) =>
  async (dispatch, getState) => {
    const properties = getState().userAttributes.property.items;

    return await dispatch(
      sendProperty({
        items: {
          ...properties,
          ...updatedProperties,
          [id]: {
            ...properties[id],
            ...updatedProperties[id],
            ...property
          }
        }
      })
    );
  };
